import React, { useEffect } from 'react';
import FormWidget from 'src/components/form-components/FormWidget/FormWidget';
import Placeholder from 'src/components/Placeholder/Placeholder';
import { IQuestion } from '../../../../entities/question';
import { ArriveTime } from './ArriveTime/ArriveTime';
import { ICalendar } from 'src/entities/calendar';
import { IService } from 'src/entities/service';
import { IValidation } from 'src/services/formValidator';
import ValidationMessage from 'src/components/form-components/ValidationMessage/ValidationMessage';
import { defineMessages, FormattedMessage } from 'react-intl';

export interface ICustomerData {
    [key: number]: string
}

interface ICustomerDataProps {
    calendar?: ICalendar;
    service?: IService;
    reservationStart?: string;
    questions: IQuestion[];
    answers: ICustomerData;
    validation?: IValidation;
    selectedArriveTime: string;
    onChange: (question: IQuestion, value: ICustomerData) => void;
    onArriveTimeChange: (value: string) => void;
    hasLoaded: boolean;
}

const messages = defineMessages({
    formInstructions: {
        id: 'formInstructions',
        defaultMessage: '* A megjelölt mezők kitöltése kötelező!'
    }
})

const CustomerData: React.FunctionComponent<ICustomerDataProps> = (props) => {

    const { service, calendar, questions, answers, reservationStart, selectedArriveTime, validation, hasLoaded } = props;

    useEffect(() => {
        questions.forEach((question) => {
            const { Id, DefaultValue } = question;
            
            if (DefaultValue) {
                answers[Id] = DefaultValue as string;
                question.DefaultValue = undefined;
                props.onChange(question, answers);
            }
        });
      }, [questions]);

      return (
        <div className="questions">
            {questions.some(q => q.Required)
                && <p className="questions__instructions"><FormattedMessage {...messages.formInstructions} /></p>}
            {service && service.HasArriveTime &&
                <ArriveTime
                    onChange={props.onArriveTimeChange}
                    calendar={calendar}
                    service={service}
                    reservationStart={reservationStart}
                    value={selectedArriveTime} />
            }
            {hasLoaded ?
                questions.map(q => q.IsHidden !== true &&
                    <div className="questions__question question" key={q.Id}>
                        <div className="question__widget">
                            <FormWidget
                                answer={answers[q.Id] as string | undefined !== undefined ? answers[q.Id] : ''}
                                question={q}
                                onChange={(value) => props.onChange(q, { ...answers, [q.Id]: value })}
                            />
                        </div>
                        {validation && validation.fields[q.Id] &&
                            <ValidationMessage
                                message={validation.fields[q.Id].message}
                                formatValues={validation.fields[q.Id].messageValues}
                            />
                        }
                    </div>
                )
                : <Placeholder />
            }
        </div>
    )
}

export default CustomerData